module.exports = ".workbench-sec-1{max-width:100%;overflow:hidden;margin:1.2em 0}.workbench-sec-1 img{border:1px solid #f0f0f0}\n"